export default "__VITE_ASSET__BJhqbh_I__"